import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import {
	supervisorDashboardDayList,
	setRecentQuickAcceptActions,
	getShiftsForQuickActions,
	setIsPerformingActionForQA
} from './supervisordashboard';
import { getOrganizationShiftTimes } from './shift';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import mixpanelConstants from '../../constants/mixpanel';
import constants from '../../services/constants';
import { FROM_DASHBOARD, FROM_QA_PANEL, FROM_SHIFT_DETAILS } from '../../constants/shift';

export const setShiftDetail = createAction('SET_SHIFT_DETAIL');
export const setShiftCancellationNotes = createAction('SET_CANCELLATION_NOTES');
export const setAppliedShiftApplicants = createAction('SET_APPLIED_SHIFT_APPLICANTS');
export const setMessageList = createAction('SET_MESSAGE_LIST');
export const setPaneValue = createAction('SET_PANE_VALUE');
export const setNurseDetail = createAction('SET_NURSE_DETAIL');
export const setmessage = createAction('SET_MESSAGE');
export const setRegistrationRegulatory = createAction('SET_REGISTRATION_REGULATORY');
export const setcprRegulatory = createAction('SET_CPR_REGULATORY');
export const setaclsRegulatory = createAction('SET_ACLS_REGULATORY');
export const setJobHistory = createAction('SET_JOB_HISTORY');
export const setauditLogList = createAction('SET_AUDIT_LOGS_LIST');
export const setauditSearchTerm = createAction('SET_AUDIT_SEARCH_TERM');

export const clearMessage = createAction('CLEAR_MESSAGES');
export const clearLicense = createAction('CLEAR_LICENSE_VAL');
export const clearRegisRegulatory = createAction('CLEAR_REGISREGULATORY_VAL');
export const clearcprvalues = createAction('CLEAR_CPR_VAL');
export const clearaclsvalues = createAction('CLEAR_ACLS_VAL');
export const clearjobhistory = createAction('CLEAR_JOBHIST_VAL');

export const setNurseRequirements = createAction('SET_USER_REQUIREMENTS_ARRAY');
export const setNurseRequirementDetails = createAction('SET_USER_REQUIREMENT_DETAILS');
export const setJobResumeFilePath = createAction('SET_JOB_RESUME_FILE_PATH');
export const setJobResumeFileName = createAction('SET_JOB_RESUME_FILE_NAME');
export const setRequirementLightBox = createAction('SET_REQUIREMENT_LIGHTBOX');
export const setReasons = createAction('SET_REASON');
export const setOpenReasonPopup = createAction('SET_OPEN_REASON_POPUP');
export const setOpenUndoRejectConfirm = createAction('SET_OPEN_UNDO_REJECT_CONFIRM');
export const setOpenRequestConfirm = createAction('SET_OPEN_REQUEST_CONFIRM');
export const setReasonValue = createAction('SET_REASON_VALUE');
export const setReasonText = createAction('SET_REASON_TEXT');
export const setRejectId = createAction('SET_REJECT_ID');
export const setRequestId = createAction('SET_REQUEST_ID');

export const setAuditPaneValue = createAction('SET_AUDIT_PANE_VALUE');
export const setNurseHistoryList = createAction('SET_NURSE_HISTORY_LIST');
export const setOpenAlertDialog = createAction('SET_OPEN_ALERTDIALOG');
export const setNdpToggleStatus = createAction('SET_NDP_TOGGLE_STATUS');

export const setDownloadingProfile = createAction('SET_DOWNLOADING_PROFILE');

export const setChangingApplicantStatus = createAction('SET_IS_CHANGING_APPLICANT_STATUS');

export const setFullShiftHistory = createAction('SET_FULL_SHIFT_HISTORY');
export const setBackfillToggleStatus = createAction('SET_BACKFILL_TOGGLE_STATUS');
export const setIsFetchingShiftDetail = createAction('SET_IS_FETCHING_SHIFT_DETAILS');
export const setInstantAcceptToggleStatus = createAction('SET_INSTANT_ACCEPT_TOGGLE_STATUS');

export const setIsUpdatingInstantAcceptStatus = createAction('SET_IS_UPDATING_IA_STATUS');

export const setMessagesFetchStatus = createAction('SET_MESSAGES_FETCH_STATUS');
export const setMessageSendErrorStatus = createAction('SET_MESSAGE_SEND_ERROR_STATUS');
export const setApplicationStatus = createAction('SET_APPLICATION_STATUS');

export const setNurseSkills = createAction('SET_NURSE_SKILLS');

const initialState = {
	aclsRegulatory: {},
	applicationStatus: '',
	appliedShiftApplicantList: [],
	auditLogList: [],
	auditSearchTerm: '',
	cprRegulatory: {},
	fullShiftHistory: {
		shift_history_in_other_facility: [],
		shift_history_in_same_facility: []
	},
	is_backfill_enable: false,
	is_instant_accept_enable: false,
	isAlertDialogOpen: false,
	isAuditPaneOpen: false,
	isChangingApplicantStatus: false,
	isFetchingShiftDetail: false,
	isPaneOpen: false,
	isUpdatingInstantAcceptStatus: false,
	jobhistory: [],
	license: {},
	lightBoxOpen: false,
	message: '',
	messageList: [],
	messageSendErrorStatus: false,
	messagesFetchStatus: false,
	ndp_toggle_status: false,
	nurse_shift_history: [],
	nurseSkills: {},
	openReasonPopup: false,
	openRequestConfirm: false,
	openUndoRejectConfirm: false,
	reasons: [],
	reasonText: '',
	reasonValue: '',
	registrationRegulatory: {},
	rejectId: '',
	requestId: '',
	requirementDetails: {},
	resumeFileName: '',
	resumeFilePath: '',
	selectedNurseDetail: {},
	shift_cancellation_notes: '',
	shiftDetails: {},
	shiftHistoryList: [],
	userRequirements: []
};

export default handleActions(
	{
		CLEAR_ACLS_VAL: (state) => ({ ...state, aclsRegulatory: initialState.aclsRegulatory }),
		CLEAR_CPR_VAL: (state) => ({ ...state, cprRegulatory: initialState.cprRegulatory }),
		CLEAR_JOBHIST_VAL: (state) => ({ ...state, jobhistory: initialState.jobhistory }),
		CLEAR_LICENSE_VAL: (state) => ({ ...state, license: initialState.license }),
		CLEAR_MESSAGES: (state) => ({ ...state, messageList: initialState.messageList }),
		CLEAR_REGISREGULATORY_VAL: (state) => ({ ...state, registrationRegulatory: initialState.registrationRegulatory }),
		SET_ACLS_REGULATORY: (state, action) => ({ ...state, aclsRegulatory: action.payload }),
		SET_APPLICATION_STATUS: (state, action) => ({ ...state, applicationStatus: action.payload }),
		SET_APPLIED_SHIFT_APPLICANTS: (state, action) => ({ ...state, appliedShiftApplicantList: action.payload }),
		SET_AUDIT_LOGS_LIST: (state, action) => ({ ...state, auditLogList: action.payload }),
		SET_AUDIT_PANE_VALUE: (state, action) => ({ ...state, isAuditPaneOpen: action.payload }),
		SET_AUDIT_SEARCH_TERM: (state, action) => ({ ...state, auditSearchTerm: action.payload }),
		SET_BACKFILL_TOGGLE_STATUS: (state, action) => ({ ...state, is_backfill_enable: action.payload }),
		SET_CANCELLATION_NOTES: (state, action) => ({ ...state, shift_cancellation_notes: action.payload }),
		SET_CPR_REGULATORY: (state, action) => ({ ...state, cprRegulatory: action.payload }),
		SET_FULL_SHIFT_HISTORY: (state, action) => ({ ...state, fullShiftHistory: action.payload }),
		SET_INSTANT_ACCEPT_TOGGLE_STATUS: (state, action) => ({ ...state, is_instant_accept_enable: action.payload }),
		SET_IS_CHANGING_APPLICANT_STATUS: (state, action) => ({ ...state, isChangingApplicantStatus: action.payload }),
		SET_IS_FETCHING_SHIFT_DETAILS: (state, action) => ({ ...state, isFetchingShiftDetail: action.payload }),
		SET_IS_UPDATING_IA_STATUS: (state, action) => ({ ...state, isUpdatingInstantAcceptStatus: action.payload }),
		SET_JOB_HISTORY: (state, action) => ({ ...state, jobhistory: action.payload }),
		SET_JOB_RESUME_FILE_NAME: (state, action) => ({ ...state, resumeFileName: action.payload }),
		SET_JOB_RESUME_FILE_PATH: (state, action) => ({ ...state, resumeFilePath: action.payload }),
		SET_LICENSE: (state, action) => ({ ...state, license: action.payload }),
		SET_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_MESSAGE_LIST: (state, action) => ({ ...state, messageList: action.payload }),
		SET_MESSAGE_SEND_ERROR_STATUS: (state, action) => ({ ...state, messageSendErrorStatus: action.payload }),
		SET_MESSAGES_FETCH_STATUS: (state, action) => ({ ...state, messagesFetchStatus: action.payload }),
		SET_NDP_TOGGLE_STATUS: (state, action) => ({ ...state, ndp_toggle_status: action.payload }),
		SET_NURSE_DETAIL: (state, action) => ({ ...state, selectedNurseDetail: action.payload }),
		SET_NURSE_HISTORY_LIST: (state, action) => ({ ...state, nurse_shift_history: action.payload }),
		SET_NURSE_SKILLS: (state, action) => ({ ...state, nurseSkills: action.payload }),
		SET_OPEN_ALERTDIALOG: (state, action) => ({ ...state, isAlertDialogOpen: action.payload }),
		SET_OPEN_REASON_POPUP: (state, action) => ({ ...state, openReasonPopup: action.payload }),
		SET_OPEN_REQUEST_CONFIRM: (state, action) => ({ ...state, openRequestConfirm: action.payload }),
		SET_OPEN_UNDO_REJECT_CONFIRM: (state, action) => ({ ...state, openUndoRejectConfirm: action.payload }),
		SET_PANE_VALUE: (state, action) => ({ ...state, isPaneOpen: action.payload }),
		SET_REASON: (state, action) => ({ ...state, reasons: action.payload }),
		SET_REASON_TEXT: (state, action) => ({ ...state, reasonText: action.payload }),
		SET_REASON_VALUE: (state, action) => ({ ...state, reasonValue: action.payload }),
		SET_REGISTRATION_REGULATORY: (state, action) => ({ ...state, registrationRegulatory: action.payload }),
		SET_REJECT_ID: (state, action) => ({ ...state, rejectId: action.payload }),
		SET_REQUEST_ID: (state, action) => ({ ...state, requestId: action.payload }),
		SET_REQUIREMENT_LIGHTBOX: (state, action) => ({ ...state, lightBoxOpen: action.payload }),
		SET_SHIFT_DETAIL: (state, action) => ({ ...state, shiftDetails: action.payload }),
		SET_USER_REQUIREMENT_DETAILS: (state, action) => ({ ...state, requirementDetails: action.payload }),
		SET_USER_REQUIREMENTS_ARRAY: (state, action) => ({ ...state, userRequirements: action.payload })
	},
	initialState
);

export const getNurseSkills = (id) =>
	function (dispatch) {
		return Agent.nurseSkills(id).then((response) => {
			if (response.ok) {
				dispatch(setNurseSkills(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getPublicShift = (token, id) =>
	function (dispatch) {
		Agent.getPublicShiftDetail(token, id).then((response) => {
			if (response.ok) {
				dispatch(setShiftDetail(response.data));
				dispatch(setNdpToggleStatus(response.data.is_ndp_enable));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getShift = (id) =>
	function (dispatch) {
		dispatch(setIsFetchingShiftDetail(true));
		return Agent.getSupervisorShiftDetail(id).then((response) => {
			dispatch(setIsPerformingActionForQA(false));
			if (response.ok) {
				['shift_starttime', 'shift_endtime', 'shift_start_bin', 'shift_end_bin', 'facility_details'].forEach((elm) => {
					delete response.data[elm];
				});
				dispatch(setShiftDetail(response.data));
				dispatch(getOrganizationShiftTimes(response.data.organization_id));
				dispatch(setNdpToggleStatus(response.data.is_ndp_enable));
				dispatch(setBackfillToggleStatus(response.data.is_backfill_enable));
				dispatch(setInstantAcceptToggleStatus(response.data.is_instant_accept_enable));
			} else {
				dispatch(handleError(response));
			}
			dispatch(setIsFetchingShiftDetail(false));

			return response;
		});
	};

export const cancelshift = (id, reason, selectedShiftDetail = undefined, actionTakenFrom, onComplete) =>
	function (dispatch, getState) {
		const { shift_cancellation_notes } = getState().supervisorshiftdetails;
		const shiftDetails = selectedShiftDetail || getState().supervisorshiftdetails.shiftDetails;

		Agent.supervisorCancelShift(id, shift_cancellation_notes, reason).then((response) => {
			if (response.ok) {
				let fromDashboard = false;
				let fromQAPanel = false;
				let fromShiftDetails = false;

				if (actionTakenFrom === FROM_DASHBOARD) {
					fromDashboard = true;
				} else if (actionTakenFrom === FROM_QA_PANEL) {
					fromQAPanel = true;
				} else if (actionTakenFrom == FROM_SHIFT_DETAILS) {
					fromShiftDetails = true;
				}

				trackShiftCancel(shiftDetails, reason, fromDashboard, fromQAPanel, fromShiftDetails);

				if (response.data != null) {
					alert('Shift successfully canceled. ', response.data);
				} else {
					alert('Shift successfully canceled.');
				}

				if (onComplete) onComplete(true, response.data);

				dispatch(getShift(id));
				dispatch(getAppliedShiftApplicant(id));

				if (actionTakenFrom === FROM_DASHBOARD || actionTakenFrom === FROM_QA_PANEL) {
					dispatch(getShiftsForQuickActions());

					// refresh the supervisor dashboard shift list
					refreshSupervisorDashboard(getState, dispatch);
				}
			} else {
				if (onComplete) onComplete(false, response.data);
				alert(response.data);
				if (response.status !== 400) {
					dispatch(handleError(response));
				}
			}
		});
	};

function trackShiftCancel(shift, selectedReason, fromDashboard, fromQAPanel, fromShiftDetails) {
	// track cancel event
	mixpanel.track(mixpanelConstants.CANCEL_SHIFT, {
		department: shift.department,
		endTime: shift.shift_end,
		fromDashboard,
		fromQAPanel,
		fromShiftDetails,
		id: shift.shift_id,
		locations: shift.location,
		nurseRoles: shift.role_list,
		organization: shift.organization,
		reason: selectedReason,
		startDate: shift.shift_date,
		startTime: shift.shift_start,
		status: shift.shift_status,
		supervisor: shift.supervisor_name
	});
}

export const getPublicAppliedShiftApplicant = (token, id) =>
	function (dispatch) {
		Agent.getPublicAppliedShiftApplicant(token, id).then((response) => {
			if (response.ok) {
				dispatch(setAppliedShiftApplicants(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getAppliedShiftApplicant = (id) =>
	function (dispatch) {
		Agent.getAppliedShiftApplicant(id).then((response) => {
			if (response.ok) {
				dispatch(setAppliedShiftApplicants(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const rejectShiftApplicant = (user_id, shift_id, fromDashboard) =>
	function (dispatch) {
		dispatch(setChangingApplicantStatus(true));
		Agent.rejectShiftApplicant(user_id, shift_id).then((response) => {
			dispatch(setChangingApplicantStatus(false));
			if (response.ok) {
				if (fromDashboard == undefined) {
					dispatch(getShift(shift_id));
					window.location.reload();
				} else {
					dispatch(supervisorDashboardDayList());
				}
			} else {
				alert(response.data);
				dispatch(handleError(response));
				// $('#appliedUsersList').removeClass('disabledbutton') TODO
			}
		});
	};

export const acceptPublicShiftApplicant = (token, user_id, shift_id) =>
	function (dispatch, getState) {
		Agent.acceptPublicShiftApplicant(token, user_id, shift_id).then((response) => {
			if (response.ok) {
				dispatch(getPublicShift(token, shift_id));
				dispatch(getPublicAppliedShiftApplicant(token, shift_id));
			} else if (getState().shiftdetail.shiftDetails.shift_status !== 'Accepted') {
				dispatch(handleError(response));
			}
		});
	};

export const acceptShiftApplicant = (
	user_id,
	shift_id,
	fromDashboard,
	fromQuickAcceptSidePanel = undefined,
	isOvertimeAccepted
) =>
	function (dispatch, getState) {
		dispatch(setChangingApplicantStatus(true));

		if (fromQuickAcceptSidePanel) {
			dispatch(setIsPerformingActionForQA(true));
		}

		Agent.acceptShiftApplicant(user_id, shift_id, isOvertimeAccepted).then((response) => {
			dispatch(setIsPerformingActionForQA(false));
			dispatch(setChangingApplicantStatus(false));
			if (response.ok) {
				if (fromDashboard == undefined) {
					dispatch(getShift(shift_id));
					window.location.reload();
				} else {
					dispatch(supervisorDashboardDayList());
				}
				let origin = 'Dashboard';
				const shifts = getState().supervisordashboard.sdDayShiftList.reduce(
					(shiftList, section) => [...shiftList, ...section.shifts],
					[]
				);

				let shiftDetail = shifts.filter((shift) => shift.shift_id == shift_id)[0];

				// Only to be executed if the appplicant was accepted from the Quick Accept Sidepanel
				if (fromQuickAcceptSidePanel) {
					const recentQuickActions = JSON.parse(
						JSON.stringify(getState().supervisordashboard.recentQuickAcceptActions)
					);
					recentQuickActions.push({
						shiftId: shift_id,
						userId: user_id
					});

					dispatch(setRecentQuickAcceptActions(recentQuickActions));
					dispatch(getShiftsForQuickActions());

					origin = 'Quick Actions Panel';
					shiftDetail = getState().supervisordashboard.shiftsForQuickActions.filter(
						(shift) => shift.shift_id == shift_id
					)[0];

					// refresh the supervisor dashboard shift list
					refreshSupervisorDashboard(getState, dispatch);
				}

				const applicant = shiftDetail && shiftDetail.shiftapplicants.filter((applicant) => applicant.id == user_id)[0];
				if (applicant) {
					TrackShiftStatusUpdate(
						mixpanelConstants.ACCEPT_NURSE_APPLIED_SHIFT,
						applicant,
						shiftDetail,
						getState().user.id,
						mixpanelConstants.NURSE_SHIFT_ACCEPTED,
						origin
					);
				}
			} else {
				// Please create a new function for displaying the new alert modal, existing
				// event handlers use this logic

				// dispatch(setOpenAlertModal(true))
				/* dispatch(setAlertMessageInfo({
						status: 'error',
						message: response.data.message || response.data
					})) */
				alert(response.data);
				dispatch(handleError(response));
				// $('#appliedUsersList').removeClass('disabledbutton') TODO
			}
		});
	};

const TrackShiftStatusUpdate = (event, applicant, shiftDetail, loggedUserId, nurseEvent, origin, applicationStatus) => {
	mixpanel.identify(applicant.id);
	mixpanel.track(nurseEvent, {
		nurseAddress: applicant.address,
		nurseEmail: applicant.email,
		nurseFirstName: applicant.first_name,
		nurseId: applicant.id,
		nurseLastName: applicant.last_name,
		nurseRole: applicant.Role,
		nurseState: applicant.state,
		nurseStatus: applicationStatus,
		origin,
		shiftDepartment: shiftDetail.department,
		shiftEndDate: shiftDetail.shiftDetail_end,
		shiftID: shiftDetail.shift_id,
		shiftLocations: shiftDetail.location,
		shiftOrganization: shiftDetail.organization,
		shiftRoles: shiftDetail.role_list,
		shiftStartDate: shiftDetail.shiftDetail_start,
		shiftStatus: shiftDetail.shiftDetail_status,
		shiftSupervisor: shiftDetail.supervisor_name,
		supervisorId: loggedUserId
	});

	mixpanel.identify(loggedUserId);
	mixpanel.track(event, {
		nurseAddress: applicant.address,
		nurseEmail: applicant.email,
		nurseFirstName: applicant.first_name,
		nurseId: applicant.id,
		nurseLastName: applicant.last_name,
		nurseRole: applicant.Role,
		nurseState: applicant.state,
		nurseStatus: applicationStatus,
		origin,
		shiftDepartment: shiftDetail.department,
		shiftEndDate: shiftDetail.shiftDetail_end,
		shiftID: shiftDetail.shift_id,
		shiftLocations: shiftDetail.location,
		shiftOrganization: shiftDetail.organization,
		shiftRoles: shiftDetail.role_list,
		shiftStartDate: shiftDetail.shiftDetail_start,
		shiftStatus: shiftDetail.shiftDetail_status,
		shiftSupervisor: shiftDetail.supervisor_name,
		supervisorId: loggedUserId
	});
};

export const sendMessage = (user, sent_by, origin, orgID) =>
	function (dispatch, getState) {
		const { message } = getState().supervisorshiftdetails;
		if (message === '') {
			alert('You must enter a message.');
			return false;
		}
		Agent.sendMessages(user.id, message, sent_by, orgID).then((response) => {
			if (response.ok) {
				dispatch(getOrganizationMessages(orgID, user.id));
				mixpanel.track(mixpanelConstants.SUPERVISOR_SENT_MESSAGE_NURSE_MESSAGE_PANEL, {
					msg: message,
					nurseEmail: user.email,
					nurseName: `${user.first_name} ${user.last_name}`,
					origin
				});
			} else {
				dispatch(setMessageSendErrorStatus(true));
				dispatch(handleError(response));
			}
		});
	};

export const getOrganizationMessages = (orgID, nurseID) =>
	function (dispatch) {
		Agent.getOrganizationMessages(orgID, nurseID).then((response) => {
			if (response.ok) {
				dispatch(setMessageList(response.data));
				dispatch(setMessagesFetchStatus(false));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getNurseShiftHistory = (id) =>
	function (dispatch) {
		Agent.getNurseShiftHistory(id).then((response) => {
			if (response.ok) {
				dispatch(setNurseHistoryList(response.data));
			} else {
				alert("Couldn't get nurse shift history", response.data);
				dispatch(handleError(response));
			}
		});
	};

export const getFullShiftHistory = (nurseID) =>
	function (dispatch) {
		Agent.getFullShiftHistory(nurseID).then((response) => {
			if (response.ok) {
				dispatch(setFullShiftHistory(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const registrationregulatory = (user_id) =>
	function (dispatch) {
		Agent.getRegistrationRegulatory(user_id).then((response) => {
			if (response.ok) {
				dispatch(setRegistrationRegulatory(response.data));
			} else {
				dispatch(setRegistrationRegulatory(null));
				dispatch(handleError(response));
			}
		});
	};
export const cprRegulatory = (user_id) =>
	function (dispatch) {
		Agent.getCPRRegulatory(user_id).then((response) => {
			if (response.ok) {
				dispatch(setcprRegulatory(response.data));
			} else {
				dispatch(setcprRegulatory(null));
				dispatch(handleError(response));
			}
		});
	};
export const aclsRegulatory = (user_id) =>
	function (dispatch) {
		Agent.getACLSRegulatory(user_id).then((response) => {
			if (response.ok) {
				dispatch(setaclsRegulatory(response.data));
			} else {
				dispatch(setaclsRegulatory(null));
				dispatch(handleError(response));
			}
		});
	};

export const jobHistory = (user_id) =>
	function (dispatch) {
		Agent.getUserJobHistories(user_id).then((response) => {
			if (response.ok) {
				dispatch(setJobHistory(response.data.job_history));
				dispatch(
					setJobResumeFilePath(response.data.user_resumes[0] ? response.data.user_resumes[0].resume_location : '')
				);
				dispatch(
					setJobResumeFileName(response.data.user_resumes[0] ? response.data.user_resumes[0].resume_file_name : '')
				);
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const clearPrevData = () =>
	function (dispatch) {
		dispatch(clearMessage());
		dispatch(clearLicense());
		dispatch(clearRegisRegulatory());
		dispatch(clearcprvalues());
		dispatch(clearaclsvalues());
		dispatch(clearjobhistory());
	};

export const fetchNurseRequirements = (user_id, useShiftReqsOnly) =>
	function (dispatch, getState) {
		const { shiftDetails } = getState().supervisorshiftdetails;

		// Call when the nurse_orgs feature toggle is on
		if (useShiftReqsOnly == true) {
			Agent.getUserRequirementsForShift(user_id, shiftDetails.shift_id).then((response) => {
				if (response.ok) {
					dispatch(setNurseRequirements(response.data));
				} else {
					dispatch(setNurseRequirements([]));
					dispatch(handleError(response));
				}
			});
			// Call when the nurse_orgs feature toggle is off
		} else {
			Agent.getUserRequirements(user_id).then((response) => {
				if (response.ok) {
					dispatch(setNurseRequirements(response.data));
				} else {
					dispatch(setNurseRequirements([]));
					dispatch(handleError(response));
				}
			});
		}
	};

export const fetchNurseRequirementToView = (user_id, req_id) =>
	function (dispatch) {
		Agent.getUserRequirementToUpdate(user_id, req_id).then((response) => {
			if (response.ok) {
				dispatch(setNurseRequirementDetails(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getAuditLogList = (shift_id) =>
	function (dispatch, getState) {
		const { auditSearchTerm } = getState().supervisorshiftdetails;

		Agent.getAuditLogs(shift_id, auditSearchTerm).then((response) => {
			if (response.ok) {
				dispatch(setauditLogList(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

// Api call to get DNR reason list
export const getPublicDNRReason = (token) =>
	function (dispatch) {
		const type = 'reject';
		Agent.getPublicDNRReason(token, type).then((response) => {
			if (response.ok) {
				dispatch(setReasons(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

// Api call to get DNR reason list
export const getDNRReason = (type = 'reject') =>
	function (dispatch) {
		Agent.getDNRReason(type).then((response) => {
			if (response.ok) {
				dispatch(setReasons(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const publicRejectShiftApplicantWithReason = (token, user_id, shift_id) =>
	function (dispatch, getState) {
		const { reasonValue } = getState().supervisorshiftdetails;
		Agent.publicRejectShiftApplicantWithReason(token, user_id, shift_id, reasonValue).then((response) => {
			if (response.ok) {
				dispatch(getPublicAppliedShiftApplicant(token, shift_id));
				// window.location.reload();
			} else {
				alert(response.data);
				dispatch(handleError(response));
			}
		});
	};

export const rejectShiftApplicantWithReason = (
	user_id,
	shift_id,
	fromQuickAcceptSidePanel = undefined,
	origin = undefined
) =>
	function (dispatch, getState) {
		if (fromQuickAcceptSidePanel) {
			dispatch(setIsPerformingActionForQA(true));
		}

		const { reasonValue, reasonText, applicationStatus } = getState().supervisorshiftdetails;
		Agent.rejectShiftApplicantWithReason(user_id, shift_id, reasonValue, reasonText).then((response) => {
			dispatch(setIsPerformingActionForQA(false));

			if (response.ok) {
				let shiftDetail = getState().supervisordashboard.sdDayShiftList.filter(
					(shift) => shift.shift_id == shift_id
				)[0];

				// Only to be executed if the appplicant was accepted from the Quick Accept Sidepanel
				if (fromQuickAcceptSidePanel) {
					const recentQuickActions = JSON.parse(
						JSON.stringify(getState().supervisordashboard.recentQuickAcceptActions)
					);
					recentQuickActions.push({
						shiftId: shift_id,
						userId: user_id
					});

					dispatch(setRecentQuickAcceptActions(recentQuickActions));
					dispatch(getShiftsForQuickActions());

					shiftDetail = getState().supervisordashboard.shiftsForQuickActions.filter(
						(shift) => shift.shift_id == shift_id
					)[0];

					// refresh the supervisor dashboard shift list
					refreshSupervisorDashboard(getState, dispatch);
				} else {
					window.location.reload();
				}

				const applicant = shiftDetail && shiftDetail.shiftapplicants.filter((applicant) => applicant.id == user_id)[0];
				if (applicant) {
					const status = applicationStatus;
					TrackShiftStatusUpdate(
						mixpanelConstants.REJECT_NURSE_APPLIED_SHIFT,
						applicant,
						shiftDetail,
						getState().user.id,
						mixpanelConstants.NURSE_SHIFT_REJECTED,
						origin,
						status
					);
				}
			} else {
				// Please create a new function for displaying the new alert modal, existing
				// event handlers use this logic

				// setOpenAlertModal(true)
				/* setAlertMessageInfo({
					status: 'error',
					message: response.data.message
				}) */
				alert(response.data);
				dispatch(handleError(response));
				window.location.reload();
			}
		});
	};

export const updateShiftNdpStatus = (shift_id, status) =>
	function (dispatch) {
		Agent.updateShiftFeature(shift_id, constants.ndp, status).then((response) => {
			if (!response.ok) {
				dispatch(handleError(response));
			}
		});
	};

export const updateShiftBackfillStatus = (shift_id, status) =>
	function (dispatch) {
		Agent.updateShiftFeature(shift_id, constants.backfill, status).then((response) => {
			if (!response.ok) {
				dispatch(handleError(response));
			}
		});
	};

export const updateShiftInstantAcceptStatus = (shift_id, status) =>
	function (dispatch) {
		dispatch(setIsUpdatingInstantAcceptStatus(true));

		Agent.updateShiftFeatureByName(shift_id, constants.instantAccept, status).then((response) => {
			dispatch(setIsUpdatingInstantAcceptStatus(false));

			if (response.ok) {
				dispatch(setInstantAcceptToggleStatus(status));
				mixpanel.track(mixpanelConstants.SUPERVISOR_INSTANT_ACCEPT_TOGGLE, {
					shift_id,
					status
				});
			} else {
				if (response.data) alert(response.data);
				dispatch(handleError(response));
			}
		});
	};

const refreshSupervisorDashboard = (getState, dispatch) => {
	dispatch(supervisorDashboardDayList());
};
